import React from "react"
import { Button, Input } from "reactstrap"

// The keyboard path to arranging a band, as table cells. Native drag and drop has none, so every
// move the band offers with a mouse is here as a control: the tier select re-tiers, the arrows
// reorder. Both bands CP administers put these in the table under their band editor.

/** A `<select>` of the band's tiers, re-tiering `row` on change. */
export const TierSelect = ({ row, tiers, value, disabled, onRetier }) => (
  <Input
    type="select"
    bsSize="sm"
    style={{ maxWidth: 200 }}
    value={value}
    disabled={disabled}
    aria-label={`Tier of ${row.name}`}
    onChange={event => onRetier(row, event.target.value)}
  >
    {tiers.map(({ key, label }) => (
      <option key={key} value={key}>
        {label}
      </option>
    ))}
  </Input>
)

/**
 * Up and down within the tier. `first` and `last` say whether the row already sits at an end of its
 * tier — the table knows, because it reads in band order.
 */
export const OrderArrows = ({ row, first, last, disabled, onShift }) => (
  <>
    <Button
      size="sm"
      color="light"
      disabled={disabled || first}
      aria-label={`Move ${row.name} earlier`}
      onClick={() => onShift(row, "up")}
    >
      <i className="bx bx-up-arrow-alt" />
    </Button>{" "}
    <Button
      size="sm"
      color="light"
      disabled={disabled || last}
      aria-label={`Move ${row.name} later`}
      onClick={() => onShift(row, "down")}
    >
      <i className="bx bx-down-arrow-alt" />
    </Button>
  </>
)
